import React from 'react';
import { string, arrayOf, oneOfType, shape } from 'prop-types';
import classNames from 'classnames/bind';
import styles from './suggestion.module.scss';

const cx = classNames.bind(styles);
export const SuggestionsContainer = ({ children, header }) => {
  const key = header.replace(/\s/g, '-');
  return (
    <div className={cx('suggestion__container')}>
      <span className={cx('suggestion__header')}>{header}</span>
      <ul className={cx('suggestion__list')}>
        {children.map((child, index) => {
          return (
            <li key={`${key}-${index}`} className={cx('suggestion__list-item')}>
              {child}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

SuggestionsContainer.displayName = 'SuggestionsContainer';
SuggestionsContainer.propTypes = {
  children: arrayOf(oneOfType([shape({}), string])).isRequired,
  header: string.isRequired,
};
